<div class="container">
  <div class="card">
    <div class="d-flex flex-row justify-content-between form-group mt-2 mb-5">
      <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(qrCode?.accountState) || !hasRouteAccess(routes.SECURE.QR.DETAILS)">
        <div class="form-group mt-2 mb-5">
          <button (click)="edit()" class="btn btn-standard action-btn" type="button">
            <i class="fa fa-edit"></i> Edit
          </button>
        </div>
      </div>
      <span></span>
      <div>
        <button (click)="returnToQrCodes()" class="btn btn-standard action-btn" type="button">
          <i class="fa fa-arrow-left"></i>&nbsp;QR Codes
        </button>
      </div>
    </div>
    <div class="card-body text-center">
      <h2>Description: {{ qrCode?.description }}</h2>
      <h2 [ngClass]="getAccountStatusUtil().getAccountTextColorClass(qrCode?.accountState) + ' !important'">
      {{ getQrCodeStatus(qrCode?.accountState) }}</h2>

      @if (qrCode?.minimumAmount === qrCode?.maximumAmount || !!qrCode?.multiPremium) {

        <h2>Amount: {{ qrCode?.minimumAmount | currency:'R' }}</h2>

        @if (qrCode?.multiPremium) {

          <h2>Multi Premium Option: {{ qrCode?.multiPremium }}</h2>
        }
      } @else {

        <h2>Minimum Amount: {{ qrCode?.minimumAmount | currency:'R' }}</h2><h2>Maximum
      Amount: {{ qrCode?.maximumAmount | currency:'R' }}</h2>
    }

    @if (!!qrCode?.notificationMobileNumber) {

      <h2>Notification Mobile Number: {{ qrCode?.notificationMobileNumber }}</h2>
    }

    @if (qrCode?.description == null || qrCode?.description.length == 0) {

      <h3>{{ qrCode?.description }}</h3>
    }
    <ng-container>
      <div [hidden]="!getAccountStatusUtil().isPaymentOutstanding(qrCode?.accountState)">
        @if (qrCode) {
          <div class="row">
            <div class="form-group col-md-12">
              <h6>Scan to Pay</h6>
              <qrcode [elementType]="'svg'"
                [errorCorrectionLevel]="'M'"
                [qrdata]="qrCode?.qrCode"
              [width]="256"></qrcode>
              <h6>Pay&#64; ({{ instanceName }}) #: {{ getPayAtNumber(qrCode?.qrCode) }}</h6>
            </div>
          </div>
        }
        <div class="row center-download-button">
          <button (click)="downloadQrCode()" class="btn action-btn download-button" type="button">
            <i class="fa fa-download"></i> Download QR Code for Printing
          </button>
        </div>
      </div>
    </ng-container>

    <div class="form-group col-md-12">
      <hr/>
      <h4>
      Log History </h4>
      <table class="table table-hover table-responsive-md">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">User</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody class="table-hover text-nowrap">
          @for (auditLog of accountLogs; track auditLog) {
            <tr>
              <td>{{ auditLog.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}</td>
              <td>{{ auditLog?.userName }}</td>
              <td>{{ auditLog.description }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
<ngx-ui-loader></ngx-ui-loader>